import styled from 'styled-components';

const PaddingContainer = styled.div`
  padding: 15px;
`;

export default PaddingContainer;
